module.exports = __webpack_public_path__ + "img/shouye-xiangmuzhichi-png.3a7ce55e.svg";